var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "editArticle"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.dataForm,
      rules: _vm.rules
    }
  }, [_c("a-card", {
    staticStyle: {
      width: "1184px"
    },
    attrs: {
      bordered: false,
      bodyStyle: {
        paddingBottom: 0
      }
    }
  }, [_c("a-row", {
    staticClass: "form-row",
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 15
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("articlelist.articleName"),
      prop: "title"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      maxLength: 50,
      placeholder: _vm.$t("public.enterPlease")
    },
    model: {
      value: _vm.dataForm.title,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "title", $$v);
      },
      expression: "dataForm.title"
    }
  })], 1)], 1)], 1)], 1), _c("div", {
    staticStyle: {
      "padding-left": "24px",
      "line-height": "32px"
    }
  }, [_vm._v(_vm._s(_vm.$t("articlelist.content")) + ":")]), _c("div", {
    staticClass: "descList"
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.dataForm
    }
  }, [_c("a-tabs", {
    staticStyle: {
      padding: "0 24px"
    },
    attrs: {
      type: "card"
    },
    on: {
      change: _vm.tabChange
    },
    model: {
      value: _vm.tabKey,
      callback: function callback($$v) {
        _vm.tabKey = $$v;
      },
      expression: "tabKey"
    }
  }, [_vm._l(_vm.dataForm.contentList, function (item, index) {
    return [item.required ? [_c("a-tab-pane", {
      key: index,
      staticStyle: {
        position: "relative"
      }
    }, [_c("span", {
      attrs: {
        slot: "tab"
      },
      slot: "tab"
    }, [_c("span", {
      staticStyle: {
        color: "#f5222d"
      }
    }, [_vm._v("*")]), _vm._v(_vm._s(item.languageName) + " ")])])] : [_c("a-tab-pane", {
      key: index,
      staticStyle: {
        position: "relative"
      },
      attrs: {
        tab: item.languageName
      }
    })]];
  })], 2), _vm.contentErr ? _c("div", {
    staticStyle: {
      color: "#f5222d",
      "padding-left": "24px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t("articlelist.descErr")))]) : _vm._e(), _vm.dataForm.contentList[_vm.tabKey] ? [_c("a-form-model-item", [_c("div", {
    staticClass: "desc"
  }, [_c("tinymce-editor", {
    key: _vm.tabKey,
    staticStyle: {
      display: "inline-block",
      width: "1110px"
    },
    on: {
      handleImgUpload: _vm.imgUpload
    },
    model: {
      value: _vm.dataForm.contentList[_vm.tabKey].content,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm.contentList[_vm.tabKey], "content", $$v);
      },
      expression: "dataForm.contentList[tabKey].content"
    }
  })], 1)])] : _vm._e()], 2)], 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      loading: _vm.saveLoading,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")))])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };